import type { ReactNode } from 'react'

import blattnerLogo from '@/assets/blattner-logo-white.png'

import './TopBar.css'

type Props = {
  /** Product name shown in Arial Black next to the Blattner logo. */
  productName: string
  /** Small-caps tagline under the product name. */
  tagline?: string
  /** Rendered before the logo (e.g. the mobile menu button). */
  leading?: ReactNode
  /** Rendered after the product lockup, left side (e.g. project switcher). */
  afterProduct?: ReactNode
  /** Right-aligned content (user chip, ...). */
  children?: ReactNode
}

/**
 * The Blattner-branded application header. Presentation-only: takes props and
 * renders — no contexts, services, or router coupling, so it stays portable.
 */
function TopBar({
  productName,
  tagline,
  leading,
  afterProduct,
  children,
}: Props) {
  return (
    <header className="topbar">
      {leading}
      <img className="topbar__logo" src={blattnerLogo} alt="Blattner" />
      <div className="topbar__divider" aria-hidden="true" />
      <div className="topbar__product">
        {productName}
        {tagline && <small>{tagline}</small>}
      </div>
      {afterProduct}
      <div className="topbar__spacer" />
      {children}
    </header>
  )
}

export default TopBar
